export default __webpack_public_path__ + "static/media/violet_neon_line.21832add.svg";